import React from "react";
import {
  CAvatar,
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { cilAccountLogout, cilReload } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import avatar8 from "./../../assets/images/user.png";
import { authState } from "src/atom/authState";
import { useRecoilState } from "recoil";

const AppHeaderDropdown = () => {
  const [auth, setAuth] = useRecoilState(authState);

  return (
    <>
      <CDropdown variant="nav-item">
        <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
          <CAvatar src={avatar8} size="md" />
        </CDropdownToggle>
        <CDropdownMenu className="pt-0" placement="bottom-end">
          <CDropdownHeader className="bg-light fw-semibold py-2">
            {auth.username?.toUpperCase()}
          </CDropdownHeader>
          <CDropdownItem href="/#/change-password">
            <CIcon icon={cilReload} className="me-2" />
            Change Password
          </CDropdownItem>
          <CDropdownItem
            onClick={() => {
              localStorage.removeItem("token");
            }}
            href="/#/login"
          >
            <CIcon icon={cilAccountLogout} className="me-2" />
            Logout
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
    </>
  );
};

export default AppHeaderDropdown;
